import http from '@/api/http'

import { UserUpdate } from '@/types/User'

import {
  PatchUserPayload,
  PatchUserResponse,
  DeleteUserPayload,
  DeleteUserResponse,
  GetMeResponse,
  AcceptLegalDocumentsPayload,
  AcceptLegalDocumentsResponse,
  LockoutStatus,
} from './types'

export const getMe = async (): Promise<GetMeResponse> => {
  const response = await http.get<GetMeResponse>(`/users/getme/`)
  return response.data
}

export const getLockoutStatus = async (): Promise<LockoutStatus> => {
  const response = await http.get<LockoutStatus>(`/users/lockout-status/`)
  return response.data
}

export const patchUser = async (payload: PatchUserPayload): Promise<PatchUserResponse> => {
  const { id, ...data } = payload

  const response = await http.patch<PatchUserResponse, UserUpdate>(`/users/${id}/`, data)
  return response.data
}

export const deleteUser = async (payload: DeleteUserPayload): Promise<DeleteUserResponse> => {
  const { id } = payload

  const response = await http.delete<DeleteUserResponse>(`/users/${id}/`)
  return response.data
}

export const acceptLegalDocuments = async (
  payload: AcceptLegalDocumentsPayload
): Promise<AcceptLegalDocumentsResponse> => {
  const response = await http.patch<AcceptLegalDocumentsResponse, AcceptLegalDocumentsPayload>(
    `/users/getme/`,
    payload
  )
  return response.data
}
